// src/data/resetPassword.js
//
// Record 688 - Greg Keeley's login review of 2026-10-01 (notes 4, 4.1, 4.2, 4.3), which Bob promised him on 2026-10-02: "a
// reset page on our own domain with a confirm field and a live requirements checklist". The reset link in the e-mail
// opens laborontherecord.com/auth/action (callbackUri, data\YCP_AUTH_EMAIL.json) instead of the Firebase default page.
// The requirements are read from the policy of record (src\data\authPolicy.js, generated from YCP_AUTH_POLICY.json) - the
// page never carries a second copy of the rule.

import { MIN_LENGTH, REQUIRES } from './authPolicy';

const TESTS = {
  'one lowercase letter': /[a-z]/,
  'one number': /[0-9]/,
  'one capital letter': /[A-Z]/,
  'one uppercase letter': /[A-Z]/,
  'one symbol': /[^A-Za-z0-9]/,
  'one special character': /[^A-Za-z0-9]/,
};

// The action link's parameters (mode, oobCode, continueUrl, lang).
export function parseAction(search) {
  const p = new URLSearchParams(String(search || ''));
  return { mode: p.get('mode') || '', oobCode: p.get('oobCode') || '', continueUrl: p.get('continueUrl') || '', lang: p.get('lang') || '' };
}

// The live checklist: one row per requirement of the policy of record, plus the confirmation matching.
// A requirement the page has no test for is listed without a tick (ok: null) - shown, never guessed.
export function checklist(password, confirm) {
  const pw = String(password || '');
  const rows = [{ label: 'At least ' + MIN_LENGTH + ' characters', ok: pw.length >= MIN_LENGTH }];
  for (const r of REQUIRES) rows.push({ label: 'At least ' + r, ok: TESTS[r] ? TESTS[r].test(pw) : null });
  rows.push({ label: 'Both entries match', ok: pw.length > 0 && pw === String(confirm || '') });
  return rows;
}
export const ready = (password, confirm) => checklist(password, confirm).every((r) => r.ok !== false);

// Plain words for the errors Firebase can return on this page (never the raw code).
export function resetError(code) {
  const c = String(code || '');
  if (c === 'auth/expired-action-code') return 'This reset link has expired. Go back to sign-in and ask for a new one.';
  if (c === 'auth/invalid-action-code') return 'This reset link has already been used or is not valid. Go back to sign-in and ask for a new one.';
  if (c === 'auth/user-disabled') return 'This account is switched off. Contact your General Chairperson.';
  if (c === 'auth/weak-password' || c === 'auth/password-does-not-meet-requirements') return 'That password does not meet the requirements listed below.';
  return 'The password could not be changed. Go back to sign-in and ask for a new link.';
}
